import { Backdrop, Box, CircularProgress } from "@mui/material";
import React from "react";
import Form from "./Form";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	getPeriods,
	getQuotaStatus,
	getUserCountries,
	reset,
} from "./quotaApprovalSlice";
import Table from "./Table";
import QuotasTable from "./QuotasTable";
import QuotaDetailsTable from "./QuotaDetailsTable";
import GraphModal from "./GraphModal";
import ButtonGroup from "./ButtonGroup";
import RejectSelectedModal from "./RejectSelectedModal";
import ApproveWithCommentModal from "./ApproveWithCommentModal";
import RejectSingleModal from "./RejectSingleModal";
import Comments from "./Comments";
import ApproveSingleWithCommentModal from "./ApproveSingleWithCommentModal";
import MessageForQuota from "./MessageForQuota";
import CollapseSection from "../../../components/ui/CollapseSection";
import { pushRoute } from "../../../store/globalSlice";
import {setState as dashboardSetSlice} from "../../Dashboard/dashBoardSlice";

export default function Quota() {
	const dispatch = useDispatch();
	const state = useSelector((state) => state.quota);
	const {
		isLoading,
		countries,
		quotaStatusList,
		periods,
		quotaForApprovalTable,
		quotaDetailsTable,
		quotaForApproval,
		popupGraphData,
		redirectedFromDashboard,
	} = state;

	const dashboardstate = useSelector((state) => state.dashboard);
	const{
		isDashboard,
	}=dashboardstate;

	useEffect(() => {
    dispatch(pushRoute("quota"));
		//dispatch(reset("refresh"));
		if(!isDashboard){
			dispatch(reset("refresh"));
			}
		console.log(redirectedFromDashboard);
		if (countries.length === 0) {
			dispatch(getUserCountries());
		}
		if (quotaStatusList.length === 0) {
			dispatch(getQuotaStatus());
		}
		if (periods.length === 0) {
			dispatch(getPeriods());
		}
		if(!isDashboard){
		dispatch(reset("refresh"));
		}
		dispatch(dashboardSetSlice("isDashboard",false));
	}, []);

	return (
		<Box>
			<Box>
				<Backdrop
					sx={{
						color: "#fff",
						zIndex: (theme) => theme.zIndex.drawer + 1,
					}}
					open={isLoading}
				>
					<CircularProgress />
				</Backdrop>
			</Box>
			<Box>
				<MessageForQuota />
			</Box>
			<CollapseSection title="Search for quota">
				<Form />
				{quotaForApproval?.length > 0 ? (
					<Box sx={{ mt: 2 }}>
						<QuotasTable />
					</Box>
				) : null}
				{popupGraphData !== null ? <GraphModal /> : null}
				<RejectSelectedModal />
				<RejectSingleModal />
				<ApproveWithCommentModal />
				<ApproveSingleWithCommentModal />
				{quotaForApproval?.length > 0 ? <ButtonGroup /> : null}
			</CollapseSection>
			{quotaDetailsTable !== null ? <QuotaDetailsTable /> : null}
			<CollapseSection title="Comments and attachments">
				<Comments />
			</CollapseSection>
		</Box>
	);
}
